import React from 'react';
export function ConversationFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("g", {
    clipPath: "url(#svg__12f10__clip0)"
  }, React.createElement("path", {
    d: "M9 0h12a3 3 0 013 3v8a3 3 0 01-3 3h-1v4h-2.764a2.008 2.008 0 01-.28-.02 2 2 0 01-1.509-1.086L14 14H9a3 3 0 01-3-3V3a3 3 0 013-3z"
  }), React.createElement("path", {
    d: "M10 20h4.236a4.995 4.995 0 01-1.472-1.764L12.146 17H9a6 6 0 01-6-6V6a3 3 0 00-3 3v8a3 3 0 003 3h1v4h2.764a2 2 0 001.789-1.106L10 20z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "svg__12f10__clip0"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}